import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import DockingData from './DockingData';

class HistoryRecord extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        dockingDataVisible: false,
        historyData: {},
    }

    show = (record = {}, data = []) => {
        this.setState({
            record,
            visible: true,
            data,
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    getColumns = () => [{
        title: '业务机会编号',
        dataIndex: 'businessOpportunityNum',
        key: 'businessOpportunityNum',
        width: 100,
    }, {
        title: '方案编号',
        dataIndex: 'evaluateSerialNumber',
        key: 'evaluateSerialNumber',
        width: 100,
    }, {
        title: '适应症',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 100,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 100,
    }, {
        title: '启动中心数',
        dataIndex: 'startSiteNum',
        key: 'startSiteNum',
        width: 80,
    }, {
        title: '筛选病例数',
        dataIndex: 'filterCaseNum',
        key: 'filterCaseNum',
        width: 80,
    }, {
        title: '随机病例数',
        dataIndex: 'randomCaseNum',
        key: 'randomCaseNum',
        width: 80,
    }, {
        title: '研究周期（月）',
        dataIndex: 'researchCycle',
        key: 'researchCycle',
        width: 80,
    }, {
        title: '版本号',
        dataIndex: 'versionNum',
        key: 'versionNum',
        width: 80,
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        width: 100,
        render: (text, record) => {
            return <div>
                <a onClick={() => this.setState({ dockingDataVisible: true, historyData: record })}>查看详情</a>
            </div>
        }
    }]

    render() {
        const { visible, loading, data, record, dockingDataVisible, historyData } = this.state;
        const { evaluateCode } = record;
        return (
            <Modal
                title="版本记录"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        临床评估单号：{evaluateCode}
                    </div>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                            scroll={{x: 500}}
                        />
                        <Modal
                            title={`查看临床报价评估-对接信息`}
                            visible={dockingDataVisible}
                            onCancel={() => this.setState({ dockingDataVisible: false })}
                            className="create-modal EditPersonModal"
                            wrapClassName="vertical-center-modal"
                            maskClosable={false}
                            width={900}
                            bodyStyle={{
                                minHeight: 700
                            }}
                            footer={<Button key="cancel" onClick={() => this.setState({ dockingDataVisible: false })}>关闭</Button>}
                        >
                            <DockingData ref={el => this.DockingDataRef = el} historyData={historyData} />
                        </Modal>
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default HistoryRecord;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/HistoryRecord.js